import React from "react";
import { NOTICEBOARD_TABLE_WIDTH } from "src/scenes/Noticeboard/components/NoticeboardTable";
import { FlexContainer, LottieAnimation } from "src/components";
import PurpleLottieJson from "../../../assets/purple-lottie.json";

const ConnectingLinkedInLoader = () => {
    return (
        <FlexContainer
            maxWidth={NOTICEBOARD_TABLE_WIDTH}
            direction="column" tDirection="column"
            color="white"
            border="1px solid #D8DEEC" borderRadius="7px"
            padding="1.5rem" width="100%" height="65dvh"
            marginTop="1.25rem"
            marginBottom="1.25rem"
            alignItems="center" justifyContent="center"
            style={{ overflowX: "auto" }}
        >
            <div style={{ width: "100%", display: "flex", flex: "row", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                <LottieAnimation animationJsonData={PurpleLottieJson} />
            </div>
            <div style={{ width: "100%", flex: "row", justifyContent: "center", alignItems: "center", textAlign: "center" }}>
                Connecting LinkedIn Account..
            </div>
        </FlexContainer>
    );
};

export default ConnectingLinkedInLoader;